import { inject, provide, Ref, ref } from "vue";
import { FileBrowserAction, fileBrowserActionsKey } from "./types";

/**
 * Publishes the enabled action list to the browser's descendants.
 *
 * Must be called from a `setup()` body — `provide()` outside of one is a no-op
 * against the wrong instance. The `Ref` is passed through rather than unwrapped
 * so consumers keep tracking action lists that are computed (`PrimaryDialog`
 * swaps its list on save state) or pushed to after mount.
 */
export const provideFileBrowserActions = (
	actions: Ref<FileBrowserAction[]>
): void => {
	provide(fileBrowserActionsKey, actions);
};

export const useFileBrowserActions = () => {
	const actions = inject(fileBrowserActionsKey, ref([]));

	const hasAction = (action: FileBrowserAction): boolean =>
		actions.value.includes(action);

	return { actions, hasAction };
};
